(function () {
	function updateSize(selectEl) {
		const descSize = document.getElementById("desc_size");
		if (!descSize || !selectEl) return;

		const selectedText = selectEl.options[selectEl.selectedIndex].text.trim();
		descSize.textContent = selectedText;
	}

	document.addEventListener("DOMContentLoaded", function () {
		const select = document.querySelector(".product-form__single-selector");
		updateSize(select);
	});

	document.addEventListener("change", function (e) {
		if (
			e.target &&
			e.target.classList.contains("product-form__single-selector")
		) {
			updateSize(e.target);
		}
	});
})();
// =====================================================
// 🔘 CLICK REMOVE HANDLER
// =====================================================

document.addEventListener("click", async function (e) {
	console.log("remove handler...");
	const btn = e.target.closest(".line-item__quantity-remove");

	if (!btn) return;

	// 👉 If it's a normal <a> → let Shopify handle it
	if (btn.tagName === "A" && !btn.dataset.key) {
		return; // ✅ allow default redirect
	}

	e.preventDefault();

	if (btn.disabled) return;
	btn.disabled = true;

	const data = {
		hash: btn.dataset.hash,
		key: btn.dataset.key,
	};

	try {
		await cartUpdate(data);
		await _updateMinFee();
		await manageSurcharge();
		document.documentElement.dispatchEvent(
			new CustomEvent("cart:refresh", {
				bubbles: true,
				detail: { scrollToTop: false },
			}),
		);
	} catch (err) {
		console.error(err);
	} finally {
		btn.disabled = false;
	}
});

// =====================================================
// 🛒 CART UPDATE (REMOVE ITEMS)
// =====================================================
const cartUpdate = ({ hash, key }) => {
	const updates = {};
	updates[key] = 0;

	const items = document.querySelectorAll(`[data-item-hash='${hash}']`);
	items.forEach((item) => {
		const itemKey = item.dataset.itemKey;
		if (itemKey) {
			updates[itemKey] = 0;
		}
	});

	return fetch("/cart/update.js", {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({ updates }),
	}).then(async (res) => {
		const data = await res.json();

		// ⚠️ Don't break on 422
		if (!res.ok) {
			console.warn("Cart update warning:", data);
		}

		return data;
	});
};

// =====================================================
// ⚙️ MAIN LOGIC (MIN FEE + IMPRINTING)
// =====================================================
async function _updateMinFee() {
	if (typeof window.manageImprintingPricing === "function") {
		return window.manageImprintingPricing();
	}

	const minFeeConfig = window.cartConfig;

	// Do not do anything if the feature is disabled or not configured
	if (
		minFeeConfig?.skip ||
		!minFeeConfig?.minFeeId ||
		!minFeeConfig?.minFeePrice
	) {
		console.log();
		return;
	}

	const minFeeId = String(minFeeConfig.minFeeId);

	const response = await fetch("/cart.js", {
		headers: {
			Accept: "application/json",
		},
	});

	if (!response.ok) {
		throw new Error(`Failed to fetch cart: ${response.status}`);
	}

	const cart = await response.json();
	const items = cart.items || [];

	// Product(s) that actually have imprinting
	const imprintingItems = items.filter(
		(item) => item?.properties?._imprintingProducts === true,
	);

	// Check whether the minimum fee product is already in the cart
	const lineItemMinFeeAdded = items.find(
		(item) => String(item.id) === minFeeId,
	);

	// Total quantity of products with imprinting
	const imprintingProductsCount = imprintingItems.reduce(
		(total, item) => total + Number(item.quantity || 0),
		0,
	);

	const shouldHaveMinFee =
		imprintingProductsCount > 0 && imprintingProductsCount < 100;

	console.log({
		imprintingItems,
		imprintingProductsCount,
		lineItemMinFeeAdded,
		shouldHaveMinFee,
	});

	// Add minimum print fee
	if (shouldHaveMinFee && !lineItemMinFeeAdded) {
		console.log("Adding minimum print fee...");

		const addResponse = await fetch("/cart/add.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
			},
			body: JSON.stringify({
				items: [
					{
						id: minFeeId,
						quantity: 1,
					},
				],
			}),
		});

		if (!addResponse.ok) {
			throw new Error(`Failed to add minimum fee: ${addResponse.status}`);
		}

		return addResponse.json();
	}

	// Remove minimum print fee if there are no qualifying
	// imprinting products or quantity has reached 100+
	if (!shouldHaveMinFee && lineItemMinFeeAdded) {
		console.log("Removing minimum print fee...");

		const updateResponse = await fetch("/cart/update.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
			},
			body: JSON.stringify({
				updates: {
					[minFeeId]: 0,
				},
			}),
		});

		if (!updateResponse.ok) {
			throw new Error(`Failed to remove minimum fee: ${updateResponse.status}`);
		}

		return updateResponse.json();
	}
}
async function __updateMinFee() {
	console.log("window.imprintingMinFee.skip", window.cartConfig.skip);
	if (
		(!window.cartConfig?.minFeeId || !window.cartConfig?.price) &&
		window.cartConfig.skip
	) {
		console.log("skipping imprinting fee");
		return; // Skip if min fee config missing
	}

	const minFeeId = window.cartConfig.minFeeId;

	console.log("updste" + minFeeId);
	const minFeePrice = window.cartConfig.price;

	const response = await fetch("/cart.js");
	const cart = await response.json();
	const items = cart.items;
	console.log(items, "__items");
	const totalImpFee = items.reduce((acc, item) => {
		if (item?.properties?._imprintingProducts === true) {
			acc += item?.line_price;
		}
		return acc;
	}, 0);

	const skipableProducts = [
		"Small Order Surcharge",
		"Imprinting -",
		"Minimum Print Fee",
	];

	const mainProductsCount = items.reduce((acc, item) => {
		if (
			!skipableProducts.some(
				(prefix) =>
					item.title.startsWith(prefix) ||
					!item?.properties?._imprintingProducts,
			)
		) {
			acc += item?.quantity;
		}
		return acc;
	}, 0);

	const lineItemMinFeeAdded = items.find(
		(item) => String(item.id) === String(minFeeId),
	);
	console.log(
		mainProductsCount,
		lineItemMinFeeAdded,
		!lineItemMinFeeAdded,
		"__lineItemMinFeeAdded",
		minFeeId,
	);
	if (mainProductsCount > 0 && mainProductsCount < 100) {
		console.log("adding min fee...");
		if (!lineItemMinFeeAdded && !window.cartConfig.skip) {
			return fetch("/cart/add.js", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					items: [{ id: minFeeId, quantity: 1 }],
				}),
			});
		}
	} else {
		if (lineItemMinFeeAdded) {
			console.log("removing min fee...");
			const updates = { [minFeeId]: 0 };
			return fetch("/cart/update.js", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ updates }),
			});
		}
	}
}

const updateMinFee = async () => {
	const minFeeId = window.cartConfig.minFeeId;
	const skipMinFee = window.cartConfig.skip;
	console.log("97 " + minFeeId);

	const res = await fetch("/cart.js");
	const cart = await res.json();
	const items = cart.items;

	const imprintingMap = new Map();
	let printCount = 0;

	items.forEach((item) => {
		if (item?.properties?._imprinting === "Imprinting") {
			const qty = Number(item.properties._imprintinQty || 0);
			const bundleHash = item.properties._bundleHash;

			printCount += Number(item.quantity || qty);

			let tierVariants = [];
			try {
				tierVariants = JSON.parse(
					item.properties._imprintingTierVariants || "[]",
				);
			} catch (error) {
				console.warn("[imprinting] invalid stored tier variants:", error);
			}

			const selectedLocations = Object.entries(item.properties)
				.filter(([key, value]) =>
					!key.startsWith("_") &&
					(value === "Plate on File" || value === "Custom Design"),
				)
				.map(([location]) => location);
			const variants = tierVariants.length
				? tierVariants
				: (selectedLocations.length ? selectedLocations : [item.properties._location])
						.filter(Boolean)
						.map((location) => ({ id: item.properties._imprintinId, location }));
			if (!variants.length && item.properties._imprintinId) {
				variants.push({ id: item.properties._imprintinId });
			}
			variants.forEach((variant) => {
				const id = Number(variant.id || 0);
				if (!id) return;
				const mapKey = `${id}:${bundleHash}:${variant.location || ""}`;
				const existing = imprintingMap.get(mapKey);
				if (existing) existing.quantity += Number(item.quantity || qty);
				else
					imprintingMap.set(mapKey, {
						id,
						quantity: Number(item.quantity || qty),
						properties: {
							_bundleHash: bundleHash,
							_imprintingProducts: true,
							...(variant.location ? { _location: variant.location } : {}),
						},
					});
			});
		}
	});

	const imprintingItems = [...imprintingMap.values()];

	const lineItemMinFeeAdded = items.find(
		(item) => String(item.id) === String(minFeeId),
	);

	console.log("139 " + lineItemMinFeeAdded);

	const matchingCartItems = items.filter(
		(item) => String(item?.properties?._imprintingProducts) === "true",
	);

	const matchingKeys = matchingCartItems.map((item) => item.key);

	const buildZeroUpdates = (keys) => {
		const obj = {};
		keys.forEach((key) => (obj[key] = 0));
		return obj;
	};

	// =====================================================
	// CASE 1 → LESS THAN MIN FEE
	// =====================================================
	if (printCount > 0 && printCount < 100) {
		if (matchingKeys.length && !skipMinFee) {
			await fetch("/cart/update.js", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					updates: buildZeroUpdates(matchingKeys),
					test: "test1",
				}),
			});
		}

		if (!lineItemMinFeeAdded && !skipMinFee) {
			await fetch("/cart/add.js", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					items: [{ id: minFeeId, quantity: 1 }],
				}),
			});
		}
	}

	// =====================================================
	// CASE 2 → GREATER OR EQUAL
	// =====================================================
	else if (printCount >= 100) {
		if (lineItemMinFeeAdded && !skipMinFee) {
			await fetch("/cart/update.js", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					updates: { [lineItemMinFeeAdded.key]: 0 },
				}),
			});
		}

		const latestRes = await fetch("/cart.js");
		const latestCart = await latestRes.json();
		const latestItems = latestCart.items;

		const itemsToAdd = [];
		const updates = {};
		const matchedKeys = new Set();

		imprintingItems.forEach((imprintItem) => {
			const sameVariantAndBundle = latestItems.filter(
				(item) =>
					Number(item.id) === Number(imprintItem.id) &&
					item.properties?._bundleHash === imprintItem.properties._bundleHash &&
					!matchedKeys.has(item.key),
			);
			const existingItem =
				sameVariantAndBundle.find(
					(item) => item.properties?._location === imprintItem.properties._location,
				) || sameVariantAndBundle[0];

			if (!existingItem) {
				itemsToAdd.push(imprintItem);
			} else {
				matchedKeys.add(existingItem.key);
				if (existingItem.quantity !== imprintItem.quantity) {
					updates[existingItem.key] = imprintItem.quantity;
				}
			}
		});

		const expectedLines = new Set(
			imprintingItems.map(
				(item) => `${item.id}:${item.properties._bundleHash}`,
			),
		);
		latestItems.forEach((item) => {
			const identity = `${item.id}:${item.properties?._bundleHash}`;
			if (
				String(item.properties?._imprintingProducts) === "true" &&
				expectedLines.has(identity) &&
				!matchedKeys.has(item.key)
			) {
				updates[item.key] = 0;
			}
		});

		if (Object.keys(updates).length) {
			await fetch("/cart/update.js", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ updates }),
			});
		}

		if (itemsToAdd.length) {
			await fetch("/cart/add.js", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					items: itemsToAdd,
				}),
			});
		}
	}

	if (printCount === 0 && lineItemMinFeeAdded && !skipMinFee) {
		await fetch("/cart/update.js", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ updates: { [lineItemMinFeeAdded.key]: 0 } }),
		});
	}
};

window.manageImprintingPricing = updateMinFee;

// =====================================================
// 🔄 AJAX UI REFRESH (NO RELOAD)
// =====================================================
async function refreshCartUI() {
	try {
		const res = await fetch("/cart.js");
		const cart = await res.json();

		// Update cart bubble count
		const bubble = document.querySelector(".header__cart-count");
		if (bubble) {
			bubble.textContent = cart.item_count;
		}

		// Refresh cart sections
		const sectionRes = await fetch("/cart?sections=cart-items,cart-footer");
		const data = await sectionRes.json();

		const itemsEl = document.querySelector("#shopify-section-cart-items");
		if (itemsEl && data["cart-items"]) {
			itemsEl.innerHTML = data["cart-items"];
		}

		const footerEl = document.querySelector("#shopify-section-cart-footer");
		if (footerEl && data["cart-footer"]) {
			footerEl.innerHTML = data["cart-footer"];
		}
	} catch (err) {
		console.error("UI refresh failed:", err);
	}
}

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

document.addEventListener("DOMContentLoaded", async () => {
	await _updateMinFee();

	// ✅ Wait for Shopify sync
	await delay(300);

	document.documentElement.dispatchEvent(
		new CustomEvent("cart:refresh", { bubbles: true }),
	);
	// await refreshCartUI();
});

//
function imprintTotal() {
	return {
		total: 0,
		async loadCart() {
			const res = await fetch("/cart.js");
			const cart = await res.json();
			let sum = 0;
			cart.items.forEach((item) => {
				if (item.properties?._imprinting === "Imprinting") {
					const price = Number(item.properties._imprintinPrice || 0);
					const qty = Number(item.properties._imprintinQty || 0);
					sum += price * qty;
				}
			});
			this.total = sum / 100;
		},
	};
}
